import {loginPath, rememberClinic} from "./lib/clinicSignIn";
import axios from "axios";
import {v4 as uuidv4} from "uuid";
import {pdf} from "@react-pdf/renderer";
import InvRecpDF from "./components/Invoice";
import {crudStorageUpload} from "./storageRequests";
import {lightFormat} from "date-fns";
import {allAsSeenBy, participationQuery} from "./services/schedule/ownParticipation";
import {reportError} from "./lib/reportError";
import {firstLoadFailedPath} from "./lib/firstLoad";
export const url = window.location.href.includes("localhost")
  ? "http://localhost:3000"
  : /staticapps/.test(window.location.href)
  ? "https://server.brightlight.ai"
  : "https://server.brightlight.ai";

export function jwtDecode(t) {
  try {
    return JSON.parse(window.atob(t.split(".")[1]));
  } catch {
    window.location.href = loginPath();
  }
}
export async function supplementaryCrud(state, requestObjs) {
  let config = {
    method: "POST",
    url: `${url}/supplementaryCrud`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + state?.jwt || "",
      "X-Tenant": state?.organization?.db || "blh",

    },
    data: JSON.stringify({
      id: state?.jwt ? jwtDecode(state.jwt).id : "",
      requestObjs: requestObjs,
    }),
  };
  return axios(config);
}
export async function apiAction(state, data, options, signal) {
  let config = {
    method: "POST",
    url: `${url}/api-action`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + state?.jwt || "",
    },
    data: JSON.stringify({
      id: state?.jwt ? jwtDecode(state.jwt).id : "",
      s3BucketName: state.organization?.s3BucketName,
      db: state.db,
      data,
      options,
    }),
    signal,
  };
  return axios(config)
    .then((res) => {
      return res;
    })
    .catch(function (error) {
      console.log("client error", error.message);
      if (error.code !== "ERR_CANCELED") window.location.href = loginPath();
    });
}

export async function confirmAppointment(state, appointmentId) {
  let config = {
    method: "POST",
    url: `${url}/appointments/${appointmentId}/confirm`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + state?.jwt || "",
      "X-Tenant": state?.db || state?.organization?.db || "blh",
    },
    data: JSON.stringify({
      db: state?.db || state?.organization?.db,
      means: "patient portal",
      pid: state?.patient?.pid,
    }),
  };
  return axios(config);
}
export async function crud(state, requestObjs, options, signal) {
  let configService = {
    method: "POST",
    url: `${url}/crud`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + state?.jwt || "",
      "X-Tenant": 'patient',
    },
    data: JSON.stringify({
      id: state?.jwt ? jwtDecode(state.jwt).id : "",
      requestObjs: requestObjs,
      options,
      db: state.organization?.db,
    }),
    signal,
  };
  return axios(configService);
}

// (verifyBookNow removed — it inserted a row into the legacy `billing`
// collection when a patient self-booked. It had no callers, and appointments
// are canonical now: the server creates the receivable plans on confirm.)

export async function loadDataForPatientLogin(state, navigate, loader, signal) {
  loader && loader("animate-spin");

  try {
    let query;
    if (state.patient?.pid) {
      query = {pid: state.patient.pid};
    } else if (state.patient?.email) {
      query = {email: state.patient.email};
    } else {
      query = {phone: state.patient?.phone};
    }

    let requestObjs = [
      {
        db: state.db,
        collection: "patients",
        parameters: [query],
        method: "findOne",
      },
      {
        db: state.db,
        collection: "doctors",
        parameters: [{lid: state.patient.lid?.[0]}],
        method: "find",
      },
      {
        db: state.db,
        collection: "appointments",
        // Every visit naming them — one whose place in it ended included, so it
        // stays theirs to see (P3, services/schedule/ownParticipation.js).
        parameters: [participationQuery(state.patient?.pid)],
        method: "find",
        findCursor: [{method: "sort", arguments: [{startAt: -1}]}],
      },
      {
        db: state.db,
        collection: "notifications",
        parameters: [
          {targetType:"patient", patientId: state.patient?.pid}],
            
          method: "find",
      },
      {
        db: state.db,
        collection: "services",
        parameters: [{lid: state.patient.lid?.[0]}],
        method: "find",
      },
      // No `cases`: that collection is the clinic's record of a case a third
      // party commissions, read only through the server's operations (blhWebServer
      // ADR 0027). Its refusal failed this whole first load, every clinic, from
      // 2026-10-22; nothing in the app read what it returned.
      {
        db: state.db,
        collection: "locations",
        parameters: [{}, {stpSecretKey: 0}],
        method: "find",
      },
      {
        db: state.db || "blh",
        collection: "serviceCriteria",
        parameters: [{lid: state.patient.lid?.[0]}],
        method: "find",
      },
      {
        db: state.db,
        collection: "insurers",
        parameters: [{}],
        method: "find",
      },
    ];

    if (state.userType === "relationship" && state.relationship) {
      requestObjs.push({
        db: state.db,
        collection: "relations",
        parameters: [{rid: state.relationship?.rid}],
        method: "findOne",
      });
    }

    let requestObjs2 = [
      {
        db: "customers",
        collection: "organizations",
        parameters: [{db: state.db}, {stpSecretKey: 0}],
        method: "findOne",
      },
    ];

   
    let res = await crud(state, requestObjs, null, signal);
    let res2 = await crud(state, requestObjs2, null, signal);
    let data = res.data;
    let data2 = res2.data;
    loader && loader("");
    const newState = {
      ...state,
      patient: data[0],
      doctors: data[1] || [],
      // Each visit as their own place in it says (§2.8 rule 4).
      appointments: allAsSeenBy(data[2] || [], state.patient?.pid),
      notifications: data[3] ? data[3][state.patient.pid] : [],
      services: data[4] || [],
      locations: data[5] || [],
      organization: data2[0] || [],
      selectedLocation: state.patient.lid?.[0],
      serviceCriteria: data[6] || [],
      insurers: data[7] || [],
      relationship: data[8]||null,
      
    
    };




    // The account opened: this device's clinic, for the next time it is asked to sign in.
    rememberClinic(state.db);
    navigate(state.destination, {
      state: newState,
    });
  } catch (error) {
    // Abandoned on purpose: nothing to say. Any other failure is reported, and
    // the patient goes back to the sign-in page, which says their account could
    // not be opened (lib/firstLoad.js).
    if (error?.code === "ERR_CANCELED" || error?.name === "CanceledError") return;
    loader && loader("");
    reportError(error, {extra: {code: "FIRST_LOAD_FAILED", status: error?.response?.status ?? null}});
    navigate(firstLoadFailedPath(state?.db), {replace: true});
  }
}

export async function viewOrganizationByUrl(u) {
  let configOrganization = {
    method: "POST",
    url: `${url}/viewOrganizationByUrl`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({url: u}),
  };
  return axios(configOrganization)
    .then((res) => {
      return res.data;
    })
    .catch(function (error) {
      console.log(error);
      window.location.href = loginPath();
    });
}

export async function getTelusHealthInsurers(state) {
  let config = {
    method: "POST",
    url: `${url}/telusHealthInsurers`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + state.jwt || "",
      "X-Tenant": state.db,
    },
    data: JSON.stringify({
      id: state.jwt ? jwtDecode(state.jwt).id : "",
    }),
  };

  return axios(config)
    .then((res) => {
      return res;
    })
    .catch(function (error) {
      console.log("Error fetching Telus health insurers:", error);
      throw error;
    });
}



/**
 * The clinic a sign-in page names (/login/<db>), as a stranger at that page may know it: its name and logo. One clinic,
 * never the list (lib/clinicSignIn.js). Null when no clinic has that name, or the answer did not come.
 */
/**
 * The clinics a patient chooses from on the portal's own sign-in page (blhWebServer GET /portalClinics): every clinic,
 * by its name and logo, in name order. Null when the answer did not come.
 */
export async function listPortalClinics() {
  try {
    const res = await axios({method: "GET", url: `${url}/portalClinics`});
    return Array.isArray(res.data) ? res.data : null;
  } catch {
    return null;
  }
}

export async function viewOrganizationByDb(db) {
  try {
    const res = await axios({
      method: "POST",
      url: `${url}/viewOrganizationByUrl`,
      headers: {"Content-Type": "application/json"},
      data: JSON.stringify({db}),
    });
    return res.data || null;
  } catch {
    return null;
  }
}
/**
 * The clinic's Terms & Services a patient accepts before setting their password. The server reads them for the clinic
 * the patient's own reset link names (blhWebServer routes/crud/viewConsentForms.js), never a clinic the page names.
 * @param {string} reset the reset token, as getResetTokenFromHref reads it
 */
export async function viewConsentForms(reset) {
  let config = {
    method: "POST",
    url: `${url}/viewConsentForms`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({reset}),
  };
  return axios(config);
}

export async function sendInvRecEmail(state, content) {
  let config = {
    method: "POST",
    url: `${url}/sendInvRec`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + state.jwt,
    },
    data: JSON.stringify({
      id: jwtDecode(state.jwt).id,
      db: state.db,
      content,
    }),
  };
  return axios(config);
}

export async function updatePreferences(state, pid, preferences) {
  let configService = {
    method: "POST",
    url: `${url}/updatePreferences`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + state.jwt,
    },
    data: {
      pid,
      db: state.db,
      ...preferences,
    },
  };
  return axios(configService).then((res) => {
    return res;
  });
}

export async function excelTransactionsReport(state, table, location) {
  let configTable = {
    method: "POST",
    url: `${url}/excelTransactionsReport`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + state.jwt,
    },
    data: JSON.stringify({
      id: jwtDecode(state.jwt).id,
      table,
      location,
      user: state.patient || state.admin,
    }),
  };
  return axios(configTable);
}

export async function applyPrepayment({
  state,
  appointmentId,
  patientId,
  refund,
  maxAmount,
}) {
  let config = {
    method: "POST",
    url: `${url}/applyPrepayment`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + state.jwt,
    },
    data: JSON.stringify({
      id: jwtDecode(state.jwt).id,
      patientId,
      database: state.db,
      appointmentId,
      refund,
      maxAmount,
    }),
  };

  return axios(config);
}
export async function fetchRescheduleOptions(state, { appointmentId, clinicianDid, from, to }) {
  const params = new URLSearchParams({ db: state.db, from: String(from), to: String(to) });
  if (clinicianDid) params.set("did", clinicianDid);

  const config = {
    method: "GET",
    url: `${url}/appointments/${appointmentId}/reschedule-options?${params.toString()}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + (state?.jwt || ""),
      "X-Tenant": state?.db || "blh",
    },
  };
  return axios(config);
}

/**
 * Check if patient can cancel/reschedule an appointment
 */
export async function checkCancellationPolicy(state, appointmentId) {
  const config = {
    method: "GET",
    url: `${url}/appointments/${appointmentId}/cancellation-policy?db=${state.db}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + (state?.jwt || ""),
      "X-Tenant": state?.db || "blh",
    },
  };
  return axios(config);
}

/**
 * Cancel an appointment (patient-initiated)
 */
export async function cancelAppointment(state, appointmentId, cancellationReason) {
  const config = {
    method: "POST",
    url: `${url}/appointments/${appointmentId}/cancel`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + (state?.jwt || ""),
      "X-Tenant": state?.db || "blh",
    },
    data: JSON.stringify({
      db: state.db,
      updateData: {
        cancelled: true,
        cancelledAt: Date.now(),
        cancellationReason: cancellationReason,
        cancelledBy: 'patient',
      },
    }),
  };
  return axios(config);
}

/**
 * Reschedule an appointment (patient-initiated)
 */
export async function rescheduleAppointment(state, appointmentId, updateData) {
  const config = {
    method: "POST",
    url: `${url}/appointments/${appointmentId}/reschedule`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + (state?.jwt || ""),
      "X-Tenant": "patient",
    },
    data: JSON.stringify({
      db: state.db,
      updateData,
    }),
  };
  return axios(config);
}


/**
 * Get available time slots for rescheduling
 */
export async function getAvailableSlots(state, doctorId, locationId, date, duration) {
  const config = {
    method: "POST",
    url: `${url}/crud`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + (state?.jwt || ""),
      "X-Tenant": "patient",
    },
    data: JSON.stringify({
      id: state?.jwt ? jwtDecode(state.jwt).id : "",
      db: state.db,
      requestObjs: [
        {
          db: state.db,
          collection: "appointments",
          parameters: [
            {
              did: doctorId,
              lid: locationId,
              cancelled: {$ne: true},
              $expr: {
                $and: [
                  {$gte: ["$startAt", new Date(date).setHours(0, 0, 0, 0)]},
                  {$lt: ["$startAt", new Date(date).setHours(23, 59, 59, 999)]},
                ],
              },
            },
          ],
          method: "find",
        },
        {
          db: state.db,
          collection: "doctors",
          parameters: [{did: doctorId}],
          method: "findOne",
        },
      ],
    }),
  };
  return axios(config);
}

export async function drugAutocomplete(state, query) {
  let configService = {
    method: "GET",
    url: `${url}/drugAutocomplete?query=${encodeURIComponent(query)}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + state.jwt,
      "X-Tenant": state?.db,
    },
    withCredentials: true,
  };
  return axios(configService).then((res) => {
    return res;
  });
}

export async function pharmAutocomplete(state, query) {
  let configService = {
    method: "GET",
    url: `${url}/pharmAutocomplete?query=${encodeURIComponent(query)}&lid=${encodeURIComponent(state.selectedLocation)}&oid=${encodeURIComponent(state?.organization?.oid)}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + state.jwt,
      "X-Tenant": state?.db,
    },
    withCredentials: true,
  };
  return axios(configService).then((res) => {
    return res;
  });
}
